/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';

export default class CategoryController extends Controller {
  // Services
  @service
  paperToaster;

  @service
  router;

  @service
  session;

  @service
  store;

  @tracked
  tagId = '';

  @tracked
  label = '';

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  errorMessage = '';

  @tracked
  tagDialogOpen = false;

  isSortable = false;

  @tracked
  deleteInProgress;

  @tracked
  deleteTagDialogOpen;

  @tracked
  saveInProgress;

  // toggleDialog opens/closes the tag dialog.
  toggleDialog() {
    this.errorMessage = '';
    this.toggleProperty('tagDialogOpen');
    if (!this.tagDialogOpen) {
      this.resetForm();
    }
  }

  @action
  toggleTagDialog() {
    this.toggleDialog();
  }

  @action
  editTag(id) {
    this.store.findRecord('posts/tag', id).then((tag) => {
      this.label = tag.get('label');
    });
    this.tagId = id;
    this.toggleDialog();
  }

  @action
  saveTag(createAnother) {
    this.saveInProgress = true;
    this.errorMessage = '';
    let promise;
    let action = 'create';

    if (isEmpty(this.tagId)) {
      promise = new Promise((resolve) => {
        let record = this.store.createRecord('posts/tag', {
          label: this.label,
          categoryId: this.get('model.category'),
          schoolId: this.get('session.school'),
          sequence: this.get('model.tags.length') + 1,
        });
        resolve(record);
      });
    } else {
      action = 'update';
      promise = new Promise((resolve) => {
        const id = this.tagId;
        this.store.findRecord('posts/tag', id).then((tag) => {
          tag.set('label', this.label);

          resolve(tag);
        });
      });
    }

    promise.then((record) => {
      return record
        .save()
        .then(() => {
          if (action === 'create') {
            // Send an event to trigger the route to refresh the model
            this.router.refresh('admin.tags.category');
          }

          this.paperToaster.show(`Tag saved successfully.`, {
            duration: 4000,
            position: 'top right',
            toastClass: 'success',
          });

          this.resetForm();

          if (createAnother) {
            document
              .querySelector('.new-tag-dialog .new-tag-label > input')
              .focus();
          } else {
            this.tagDialogOpen = false;
          }
        })
        .catch((err) => {
          this.handleError(err, action);
          record.rollbackAttributes();
        })
        .then(() => {
          this.saveInProgress = false;
        });
    });
  }

  @action
  deleteTag(id) {
    this.errorMessage = '';
    this.store.findRecord('posts/tag', id).then((tag) => {
      this.label = tag.get('label');
    });
    this.tagId = id;
    this.deleteTagDialogOpen = true;
  }

  @action
  confirmDelete(confirmed) {
    return new Promise((resolve, reject) => {
      if (confirmed) {
        // Deletion confirmed; actually delete the record.
        this.deleteInProgress = true;

        // Grab record from local store - no GET request, as that causes weirdness.
        // We only need the ID to issue the DELETE anyway, which can't change, so no need to use findRecord.
        let field = this.store.peekRecord('posts/tag', this.tagId);

        // Delete record (locally + pushed to server).
        return field
          .destroyRecord()
          .then(resolve)
          .catch((err) => {
            // Remove 'deleted' flag so that entity can be interacted with again.
            field.rollbackAttributes();
            reject(err);
          });
      } else {
        resolve();
      }
    })
      .then(() => {
        // Tidy up / close dialog.
        this.deleteTagDialogOpen = false;
        this.resetForm();
      })
      .catch((err) => {
        this.handleError(err, 'delete');
      })
      .then(() => {
        this.deleteInProgress = false;
      });
  }

  // drag-drop sorting
  @action
  sortDragEnd({ sourceList, sourceIndex, targetList, targetIndex }) {
    if (sourceList === targetList && sourceIndex === targetIndex) {
      return;
    }

    const item = sourceList[sourceIndex];

    sourceList.splice(sourceIndex, 1);
    targetList.splice(targetIndex, 0, item);

    targetList.forEach((entity, index) => {
      entity.set('sequence', index + 1);
      entity.save();
    });
  }

  handleError(err) {
    if (!isEmpty(err.errors.msg)) {
      this.errorMessage = err.errors.msg;
    } else if (!isEmpty(err.errors[0])) {
      let error = err.errors[0];
      if (!isEmpty(error.detail)) {
        this.errorMessage = error.detail;
      }
    } else {
      this.errorMessage = err.message;
    }
  }

  resetForm() {
    this.tagId = '';
    this.label = '';
  }
}
